import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayoutRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.5 4.5V9h3V4.5zM3 4.5A1.5 1.5 0 0 1 4.5 3h3A1.5 1.5 0 0 1 9 4.5V9a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 3 9zm9.5 6.5v4.5h3V11zM11 11a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 17 11v4.5a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zm-3.5 3h-3v1.5h3zm-3-1.5h3A1.5 1.5 0 0 1 9 14v1.5A1.5 1.5 0 0 1 7.5 17h-3A1.5 1.5 0 0 1 3 15.5V14a1.5 1.5 0 0 1 1.5-1.5m8-8V6h3V4.5zm-1.5 0A1.5 1.5 0 0 1 12.5 3h3A1.5 1.5 0 0 1 17 4.5V6a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 11 6z" })
});
export default SvgLayoutRegularIcon;
